import { render, staticRenderFns } from "./ImportIntegrationModal.vue?vue&type=template&id=21676c60&scoped=true&"
import script from "./ImportIntegrationModal.vue?vue&type=script&lang=js&"
export * from "./ImportIntegrationModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportIntegrationModal.vue?vue&type=style&index=0&id=21676c60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21676c60",
  null
  
)

export default component.exports